module.exports = __webpack_public_path__ + "static/media/zhiyinshouce2.bb70c77c.png";